
import { Vue, Component, Prop } from "vue-property-decorator";

import InfoDetailsWrapper from "@/components/inforationCards/InfoDetailsWrapper.vue";
import FormattedDescription from "@/components/common/FormattedDescription.vue";
import Chip from "@/components/filters/Chip.vue";
import InformationCard from "@/components/inforationCards/InformationCard.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import EmptyListImageRequests from "@/components/icons/emptyListImages/EmptyListImageRequests.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import {
  Custom_Request,
  Tag
} from "@/generated/graphql";
import moment from "moment";
import GET_TAG from "@/apollo/requests/GetTag.gql";
import { request } from "http";
import S3Image from "@/components/common/s3-image.vue";


@Component({
  components: {
    InfoDetailsWrapper,
    InformationCard,
    FormattedDescription,
    Chip,
    EmptyListPlaceholder,
    EmptyListImageRequests,
    S3Image,
  },
  apollo: {
    contractor_type: {
      query: GET_TAG,
      variables() {
        return {
          id: this.request?.tag_id,
        };
      },
      update(data) {
        return data.tag_by_pk;
      },
    },
  },
})
export default class ResourcesDetails extends Vue {
  @Prop({ type: Object, default: undefined }) readonly request!: Custom_Request;
  @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
  @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;

  placeholder: string = NO_INFORMATION;
  contractor_type: Tag = undefined;
  // request2:any=this.request;

  getFormattedDate(date: any): string {
    return moment(date).format("DD/MM/YY")
  }

  getFormattedNumber(num: any): number {
    if (!num) {
      return 0;
    }
    return num;
  }
  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center justify-center";
  }
  
  get bgStyle(): object {
    return {
      background: "#1c64f2",
    };
  }
  get avatarStyleClasses(): Record<string, boolean> {
    return {
      [this.avatarClasses]: Boolean(this.avatarClasses),
      ["border border-primary"]: this.highlightAvatar,
    };
  }
  get defaultImageClasses(): string {
    return "inline-block rounded-full object-cover object-center";
  }
}
